<template>
    <el-dialog title="修改密码" :visible.sync="showDialog" @close="handleClose" width="600px">
        <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
            <el-form-item label="旧密码" prop="oldPass">
                <el-input type="password" v-model="form.oldPass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPass">
                <el-input type="password" v-model="form.newPass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPass">
                <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">取 消</el-button>
            <el-button type="primary" @click="submitForm()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { changePassword } from '@/util/request'

export default {
    name: 'ChangePasswordDialog',
    props: {
        // 可以添加其他需要的属性，比如初始密码等
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        var validateOldPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入旧密码'));
            } else {
                callback();
            }
        };
        var validateNewPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'));
            } else {
                if (this.form.checkPass !== '') {
                    this.$refs.form.validateField('checkPass');
                }
                callback();
            }
        };
        var validateCheckPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.newPass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            showDialog: false,
            form: {
                oldPass: '',
                newPass: '',
                checkPass: ''
            },
            rules: {
                oldPass: [
                    { validator: validateOldPass, trigger: 'blur' }
                ],
                newPass: [
                    { validator: validateNewPass, trigger: 'blur' },
                    { min: 6, message: '长度在6个字符以上', trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validateCheckPass, trigger: 'blur' }
                ]
            }
        };
    },
    watch: {
        show: function (n, o) {
            this.showDialog = n
        }
    },
    methods: {
        open() {
            this.show = true;
        },
        handleClose() {
            this.$refs['form'].resetFields();
            // 给父元素传值，关闭对话框
            this.$emit('update:show', false)
        },
        submitForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    changePassword({
                        oldPassword: this.form.oldPass,
                        newPassword: this.form.newPass
                    }).then(res => {
                        if (res.resultCode == 1) {
                            this.$message.success('修改成功，请重新登陆')
                            this.$router.push('/login')
                            this.showDialog = false;
                        } else
                            this.$message.error(res.info)
                    })
                    
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
/* 添加任何必要的样式 */
</style>


// WEBPACK FOOTER //
// src/components/main/ChangePassword.vue